import React, { useEffect, useState } from "react";
import { CloudOff, AlertCircle, Loader2, RefreshCcw } from "lucide-react";
import syncRunner from "../lib/syncRunner";

/**
 * Small pill rendered above the bottom nav showing the live outbox
 * state. Hidden when there is nothing pending. Tapping it forces an
 * immediate sync attempt.
 *
 * States:
 *   - pending (paused: false)   → grey, "Loader2"
 *   - pending (paused: true)    → amber, "CloudOff" + "Session expired"
 *   - errored                    → red, "AlertCircle"
 */
export default function OutboxIndicator() {
  const [snap, setSnap] = useState({ pending: 0, errored: 0, paused: false, total: 0 });

  useEffect(() => {
    return syncRunner.subscribe(setSnap);
  }, []);

  if (!snap || snap.total === 0) return null;

  let color;
  let label;
  let Icon;
  if (snap.errored > 0 && snap.pending === 0) {
    color = "bg-shelf-expired-bg text-shelf-expired border-shelf-expired";
    label = `${snap.errored} sync failed`;
    Icon = AlertCircle;
  } else if (snap.paused) {
    color = "bg-shelf-attention-bg text-shelf-attention border-shelf-attention";
    label = `${snap.total} queued · sign in`;
    Icon = CloudOff;
  } else {
    color = "bg-secondary text-ink/80 border-border";
    label = `${snap.pending} pending sync${snap.errored ? ` · ${snap.errored} failed` : ""}`;
    Icon = Loader2;
  }

  return (
    <button
      type="button"
      onClick={() => syncRunner.kick("manual")}
      data-testid="outbox-indicator"
      className={`fixed bottom-[78px] left-1/2 -translate-x-1/2 z-20 inline-flex items-center gap-2 px-3 py-1.5 rounded-full border ${color} font-mono text-[11px] uppercase tracking-wider shadow-sm`}
      title="Tap to retry now"
    >
      <Icon size={13} className={snap.pending && !snap.paused ? "animate-spin" : ""} />
      <span>{label}</span>
      <RefreshCcw size={11} className="opacity-70" />
    </button>
  );
}
